export interface SectorProfile {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  description: string;
  subCategories: string[];
  keyAttendees: string[];
  iconName: string;
}

export const focusSectors: SectorProfile[] = [
  {
    id: 'agrochemicals-crop-protection',
    number: 1,
    title: 'Agrochemicals & Crop Protection',
    subtitle: 'Technical Manufacturers, Formulators & Biological Solutions',
    description:
      'Manufacturers of active ingredients (technical grades), bulk formulators, bio-pesticides, organic formulations, and synthetic crop defense chemistry serving domestic and export markets.',
    subCategories: [
      'Technical Grade Active Ingredient (AI) Manufacturers',
      'Formulators (EC, SC, WG, WP, OD formulations)',
      'Biological Pest Control & Microbial Formulations',
      'Botanical Extracts & Bio-fungicides',
      'Seed Treatment Chemicals & Soil Conditioners',
    ],
    keyAttendees: [
      'Procurement Heads',
      'Formulation Scientists',
      'Distributor Principals',
      'Export Trading Houses',
    ],
    iconName: 'ShieldCheck',
  },
  {
    id: 'allied-specialty-chemicals',
    number: 2,
    title: 'Allied & Specialty Chemicals',
    subtitle: 'Surfactants, Solvents, Adjuvants & Chemical Intermediates',
    description:
      'Suppliers of green solvents, advanced wetting agents, emulsifiers, performance adjuvants, and specialty chemical intermediates critical for modern high-efficiency agrochemical formulations.',
    subCategories: [
      'Surfactants & Non-ionic Wetting Agents',
      'Agricultural Solvents & Polar Carriers',
      'Spray Adjuvants & Drift Retardants',
      'Fine Chemical Intermediates & Reagents',
      'Chelating Agents (EDTA, EDDHA, Amino Acid complexes)',
    ],
    keyAttendees: [
      'Specialty Chemical Sourcing Managers',
      'R&D Chemists',
      'Plant Operations Directors',
      'Technical Service Heads',
    ],
    iconName: 'FlaskConical',
  },
  {
    id: 'research-testing-regulatory',
    number: 3,
    title: 'Research, Testing & Regulatory',
    subtitle: 'GLP Laboratories, Product Registration & Multi-Location Field Trials',
    description:
      'Certified testing laboratories, contract research organizations (CROs), ecotoxicology stations, and regulatory consulting firms facilitating CIB&RC dossier submissions and global registrations.',
    subCategories: [
      'GLP-Accredited Analytical Laboratories',
      'Multi-Location Bio-Efficacy & Residue Field Trials',
      'Ecotoxicology & Environmental Fate Testing',
      'Central Insecticides Board (CIB&RC) Registration Dossiers',
      'Global Regulatory Compliance (EPA, REACH, OECD Guidelines)',
    ],
    keyAttendees: [
      'Regulatory Affairs Directors',
      'Chief Scientific Officers',
      'Clinical Trial Managers',
      'Quality Assurance Leads',
    ],
    iconName: 'Microscope',
  },
  {
    id: 'processing-formulation-equipment',
    number: 4,
    title: 'Processing, Formulation & Equipment',
    subtitle: 'Machinery, High-Barrier Packaging & Toll Manufacturing Facilities',
    description:
      'Engineered processing equipment, bead mills, high-shear homogenizers, automated filling lines, UN-certified HDPE packaging bottles, and contract toll manufacturing facilities.',
    subCategories: [
      'High-Energy Wet Bead Mills & Air Jet Mills',
      'Industrial Homogenizers & Mixing Tanks',
      'High-Barrier Fluorinated HDPE Bottles & Corrugated Packaging',
      'Automated Liquid & Powder Filling/Sealing Lines',
      'Toll & Custom Synthesis Manufacturing Plants',
    ],
    keyAttendees: [
      'Factory Operations Managers',
      'Packaging Engineers',
      'Supply Chain VPs',
      'Toll Manufacturing Partners',
    ],
    iconName: 'Factory',
  },
  {
    id: 'financial-institutions-advisory',
    number: 5,
    title: 'Financial Institutions & Advisory',
    subtitle: 'Agri-Banking, M&A Deal Advisory & Strategy Consulting',
    description:
      'Investment banks, private equity firms, agricultural credit rating agencies, and strategic advisors guiding mergers, acquisitions, toll manufacturing agreements, and trade finance.',
    subCategories: [
      'Specialized Agri-Business Investment Banking',
      'M&A Advisory & Joint Venture Structuring',
      'Working Capital & Commodity Trade Finance',
      'ESG & Green Chemistry Transition Advisory',
      'Strategic Market Intelligence & Supply Chain Consulting',
    ],
    keyAttendees: [
      'Private Equity Partners',
      'Corporate Development Officers',
      'Commercial Agri-Bankers',
      'Chief Financial Officers',
    ],
    iconName: 'Landmark',
  },
  {
    id: 'agtech-digitization',
    number: 6,
    title: 'AgTech & Digitization',
    subtitle: 'Precision Ag, Bio-stimulants & Digital Supply Chain Platforms',
    description:
      'Next-generation digital agriculture platforms, drone spray monitoring systems, IoT soil telemetry, specialized bio-stimulant consortia, and traceable QR-code seed-to-shelf tracking solutions.',
    subCategories: [
      'Precision Drone Spraying & Formulation Compatibility Systems',
      'IoT Sensor Telemetry & Soil Health Diagnostics',
      'Biostimulants, Seaweed Extracts & Microbial Consortia',
      'B2B Ag-Input Marketplaces & Traceability Platforms',
      'Predictive Weather & Pest Outbreak Modeling',
    ],
    keyAttendees: [
      'AgTech Founders',
      'Digital Transformation Heads',
      'Bio-Stimulant Product Managers',
      'Agronomy Innovation Leads',
    ],
    iconName: 'Cpu',
  },
];

export default focusSectors;
